// Kenyan mobile — digits only, 01XXXXXXXX / 07XXXXXXXX / 254(1|7)XXXXXXXX
export const isValidKenyanMobile = (phone) =>
  /^(?:0[17]\d{8}|254[17]\d{8})$/.test((phone || "").toString());

// ID number — passport: >=7 non-space chars; others: >=7 digits
export const isValidIdNumber = (id, isPassport) => {
  const v = (id || "").toString();
  return isPassport ? /^\S{7,}$/.test(v) : /^\d{7,}$/.test(v);
};

// Input sanitizers applied while typing
export const sanitizeMobileInput = (raw) => (raw || "").replace(/\D/g, "").slice(0, 12);
export const sanitizeIdInput = (raw, isPassport) =>
  isPassport ? (raw || "").replace(/\s/g, "") : (raw || "").replace(/\D/g, "");
